import {gsap, Quart} from 'gsap/all';
import utils from '@/_modules/utils';
import $transitions from '@/_modules/Transitions';
import historyApi from '@/_modules/common/historyApi';

class _modalCase {
  constructor() {
    this.isStart = false;
    this.isOpen = false;
  }

  start() {
    this.isStart = true;
  }

  init() {
    this.modal = document.getElementById('c-modalWrap--case');
    this.binds = [];
    this.caseBox = document.querySelectorAll('.c-caseBox');
    this.caseBox.forEach((el, i) => {
      this.binds[i] = this.openModal.bind(this, el.href);
      el.addEventListener('click', this.binds[i]);
    });
  }

  openModal(href, e) {
    if (e) e.preventDefault();
    if (this.isOpen) return;
    this.isOpen = true;
    historyApi.changeState(href);
    this.get(href);
    this.showModal();
  }

  openModalState(href) {
    if (this.isOpen) return;
    this.isOpen = true;
    this.get(href);
    this.showModal();
  }

  showModal() {
    this.modal.style.pointerEvents = 'none';
    this.modal.style.visibility = 'hidden';
    this.modal.style.display = 'block';

    this.bindClose = this.closeModal.bind(this);
    this.modal.querySelector('.c-modalWrap__close').addEventListener('click', this.bindClose);
    this.modal.querySelector('.c-modalWrap__close2 a').addEventListener('click', this.bindClose);

    $transitions.show(this.openModalCover.bind(this));
  }

  openModalCover() {
    this.modal.style.pointerEvents = 'auto';
    this.modal.style.visibility = 'visible';
    requestAnimationFrame(this.openModalComp.bind(this));
  }

  openModalComp() {
    $transitions.hide();
  }

  get(href) {
    this.topTitle = document.title;
    this.topDescription = document.querySelector("meta[name='description']").getAttribute('content');

    fetch(href)
      .then((res) => res.text())
      .then((text) => {
        // テキストをDOMに変換する
        return new DOMParser().parseFromString(text, 'text/html');
      })
      .then((dom) => {
        //document.body.append(dom);
        this.modal.querySelector('.c-modalWrap__wrap').append(dom.getElementById('c-case'));

        this.setMeta(dom);
      });
  }

  setMeta(dom) {
    /** metaタグ差し替え */
    document.title = dom.querySelector('title').textContent;
    const head_description = dom.querySelector("meta[name='description']").getAttribute('content');
    if (head_description !== null) document.querySelector("meta[name='description']").setAttribute("content", head_description);
  }

  closeModal(e) {
    if (e) e.preventDefault();
    historyApi.changeState(gAMBR.rootPath);
    this.hideModal();
  }

  closeModalState() {
    this.hideModal();
  }

  hideModal() {
    this.isOpen = false;
    $transitions.show(this.closeModalCover.bind(this));
    this.modal.querySelector('.c-modalWrap__close').removeEventListener('click', this.bindClose);
    this.modal.querySelector('.c-modalWrap__close2 a').removeEventListener('click', this.bindClose);
    delete this.bindClose;
  }

  closeModalCover() {
    this.modal.scrollTop = 0;
    this.modal.style.pointerEvents = '';
    this.modal.style.visibility = '';
    this.modal.style.display = 'none';
    this.modal.querySelector('.c-modalWrap__wrap').querySelector('#c-case').remove();

    requestAnimationFrame(this.closeModalComp.bind(this));
  }

  closeModalComp() {
    document.title = this.topTitle;
    document.querySelector("meta[name='description']").setAttribute('content', this.topDescription);
    $transitions.hide();
  }

  reset() {
    this.caseBox.forEach((el) => {
      el.removeEventListener('click', this.binds[i]);
    });
    delete this.caseBox;
    delete this.binds;
    delete this.modal;
  }
}

const modalCase = new _modalCase();

export default modalCase;